import { render, staticRenderFns } from "./OrganizationRequestList.vue?vue&type=template&id=ab012c7c&"
import script from "./OrganizationRequestList.vue?vue&type=script&lang=js&"
export * from "./OrganizationRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports